<script lang="ts">
  export let size: string = "0px";
  export let class_ext: string = "noclass";
</script>

<div style="height:{size}" class={class_ext}>&nbsp;</div>

<style>
  @media (max-width: 767.99px) {
    .mobile-0rem {
      height: 0rem !important;
    }
  }
</style>